import { Component } from "react"

import { getLogger } from "@/lib/logging.ts"

import type { PropsWithChildren, ReactNode } from "react"


const log = getLogger("ErrorBoundary")

// eslint-disable-next-line no-restricted-syntax
export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = {
    error: null,
  }

  static getDerivedStateFromError(error: Error) {
    return { error }
  }

  componentDidCatch(error: Error) {
    if (!this.props.renderError) {
      log.error("Uncaught error", error)
    }
    this.setState({ error })
  }

  render() {
    return this.state.error ? this.props.renderError : this.props.children
  }
}

type ErrorBoundaryProps = PropsWithChildren & {
  renderError?: ReactNode
}

type ErrorBoundaryState = {
  error: Error | null
}